export default {
  admin: require('./admin').default,
  authentication: require('./authentication').default,
  corporate: require('./corporate').default,
  otp: require('./otp').default,
  personal: require('./personal').default,
  registration: require('./registration').default,
};
